import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Whenever the route changes, instantly scroll to the top-left corner
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component is invisible, it just runs code
}